<template>
    <header>
        <div class="main">
            <div class="edge">
                <router-link :to="{ name: 'Catches' }">
                    <img title="Gå til forsiden" src="/images/btn-logo-lk.ico" />
                </router-link>
            </div>
            <div class="title">{{ title }}</div>
            <div class="edge">
                <router-link v-if="!isAuthenticated" :to="{ name: 'Auth' }">
                    <img title="Logg inn" src="/images/btn-profile-lk.svg" />
                </router-link>
                <router-link v-if="isAuthenticated" :to="{ name: 'ProfilePage' }">
                    <img title="Min profil" :src="profile.picture" />
                </router-link>
            </div>
        </div>
        <nav>
            <CatchNavBar v-if="navbar === 'CatchList'" />
            <ProfileNavBar v-if="navbar === 'ProfilePage'" />
        </nav>
        <TheAddButton />
        <TheToaster />
    </header>
</template>

<script>
import { mapState } from 'vuex';
import { Bus, Stops } from '../../common/bus';
import CatchNavBar from '../catches/CatchNavBar.vue';
import ProfileNavBar from '../profile/ProfileNavBar.vue';
import TheAddButton from './TheAddButton.vue';
import TheToaster from './TheToaster.vue';

export default {
    components: {
        CatchNavBar, TheAddButton, TheToaster, ProfileNavBar,
    },
    data() {
        return {
            title: 'Draugen',
            navbar: null,
        };
    },
    created() {
        Bus.$on(Stops.TITLE_CHANGED, title => {
            this.title = title;
        });
        Bus.$on(Stops.NAVBAR, navbar => {
            this.navbar = navbar;
        });
    },
    computed: {
        ...mapState('session', ['country', 'profile', 'isAuthenticated']),
    },
};
</script>

<style lang="scss">
header {
    display: flex;
    flex-direction: column;
    .main {
        display: flex;
        height: 3.8rem;
        .title {
            text-align: center;
            font-size: 1.2rem;
            font-weight: bold;
            padding-top: 0.6rem;
            flex: 1;
        }
    }
    img {
        width: 2rem;
        margin: 0.5rem;
    }
    nav {
        justify-content: floor;
        flex: 1;
        flex-direction: row;
        text-align: left;
    }
}
</style>
